<template lang = "pug">
    v-container.pa-2.modal-card__container(fluid  fill-height)
        v-layout.modal-card__wrapper
          v-row
              v-card.modal-card(@click='openDialog("createPurchase")')
                  v-icon mdi-home
                  .subtitle
                      |Nueva factura de compra
              v-card.modal-card(@click='openDialog("createTransfer")')
                  v-icon mdi-home
                  .subtitle
                      |Realizar un traslado
              v-card.modal-card(@click='openDialog("createProduct")')
                  v-icon mdi-home
                  .subtitle
                      |Crear Producto
              v-card.modal-card(@click='openDialog("createCategory")')
                  v-icon mdi-home
                  .subtitle
                      |Nueva categoria
              v-card.modal-card(@click='openDialog("createShop")')
                  v-icon mdi-home
                  .subtitle
                      |Nueva tienda

        <!--v-card(  hover flat  style="cursor:pointer").my-2.reload-container-->
        <!--v-layout(column )-->
        <!--&lt;!&ndash;v-img(:src='createPropertyIcon', min-height='100px' min-width='250px', alt='')&ndash;&gt;-->
        <!--v-card(  hover  flat style="cursor:pointer").my-2.reload-container-->
        <!--&lt;!&ndash;v-img(:src='createBlogIcon', min-height='100px' min-width='250px'  alt='')&ndash;&gt;-->
</template>

<script>

  export default {

    components: {
    },
    data: () => ({
    }),
    computed: {
    },
    mounted () {
    },
    methods: {
      openDialog (name) {
        const vm = this
        vm.$store.dispatch('dialogs/openDialog', name).then(function () {
          //
          vm.closeModal()
        })
      },
      closeModal () {
        this.$store.dispatch('dialogs/closeCreateDialog').then(function () {
          //
        })
      },

    },
  }
</script>

<style lang = 'scss'  scoped>

    $break-large: 1200px;
    $primary-color: #c29f52;

    .modal-card {
      height: 150px;
      width: 150px;
      margin: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      &__container {
        display: flex;
        flex-direction:row;
        justify-content: flex-start;
        align-items: flex-start;
        background: rgba(#fff,0.5);
        height: 100%;
        width: 100%;

      }
    }
    .question{
        font-size: 1.3rem;
        color: rgb(132,132,132);
    }
    .select .v-input__control{
        width: 100% !important;
    }
    .menuable__content__active{
        top: 60px !important;
        left: 0 !important;
    }
    label.v-label{
        color: #000 !important;
    }
    .v-input__slot:before{
        background: $primary-color !important;
    }
    .user-login__field{
        width: 250px;
    }
    .user-login__field input[type="text"]{
        text-align: center !important;
    }

    .profile{
        .profile__title{
            font-size: 2rem;
            font-weight: 900;

            color: rgba(#000,0.7);
        }
        .profile__avatar{

            border-radius: 50%;

        }
        .avatar-container{
            border-radius: 50%;
            border: 1px solid rgba(red,0.4);
            overflow: hidden;
            padding: 5px;
        }
    }

</style>
